<template>
  <div class="lime-sidebar">
            <div class="lime-sidebar-inner slimscroll">
                <ul class="accordion-menu" id="accordion-menu">
                    <li v-if="isAdmin">
                        <!-- <a href="index.html" class="active"><i class="material-icons">dashboard</i>Dashboard</a> -->
                        <router-link to="/admindashboard"><i class="material-icons">dashboard</i>Dashboard</router-link>
                    </li>
                    <li v-if="isUser">
                        <!-- <a href="index.html" class="active"><i class="material-icons">dashboard</i>Dashboard</a> -->
                        <router-link to="/userdashboard"><i class="material-icons">dashboard</i>Dashboard</router-link>
                    </li>
                    <li v-if="isAdmin">
                        <!-- <a href="/invoice"><i class="material-icons">description</i>Invoices</a> -->
                        <router-link to="/invoice"><i class="material-icons">description</i>Invoices</router-link>
                    </li>
                    <li v-if="isAdmin">
                        <router-link to="/payment"><i class="material-icons">attach_money</i>Payments</router-link>
                    </li>
                    <!--<li v-if="isUser">
                        <router-link to="/userpayment"><i class="material-icons">attach_money</i>Payments</router-link>
                    </li>-->

                    <li v-if="isAdmin">
                        <router-link to="/user"><i class="material-icons">group</i>Users</router-link>
                    </li>
                    <li v-if="isAdmin">
                        <router-link to="/brands"><i class="material-icons">local_florist</i>Brands</router-link>
                    </li>
                    <!--<li>
                        <a href="profile.html"><i class="material-icons">person_outline</i>Profile</a>
                    </li>-->
                </ul>
            </div>
        </div>
</template>
<script>
  export default {
    name: 'LeftSidebar',
    data () {
      return {
        role: localStorage.getItem('role')
      }
    },
    computed: {
      isAdmin () {
        return this.role && this.role === 'admin'
      },
      isUser () {
        return this.role && this.role === 'user'
      }
    },
    methods: {

    },
    mounted () {
      var ul = document.getElementById('accordion-menu')
      ul.onclick = function (event) {
        var body = document.body
        body.classList.remove('background--blur')
        body.classList.remove('sidebar-show')
        document.getElementById('navigation-toggle1').style.display = 'block'
        document.getElementById('navigation-toggle2').style.display = 'none'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/sidebar/LeftSidebar.vue